<template>
  <div class="navbar">
    <div class="content">
      <!-- <el-radio-group v-model="isCollapse" style="margin-bottom: 20px">
        <el-radio-button :label="false">展开</el-radio-button>
        <el-radio-button :label="true">收起</el-radio-button>
        :collapse="isCollapse"
      </el-radio-group> -->
      <el-menu
        :default-active="defaultActive($route.path)"
        :unique-opened="true"
        class="el-menu-vertical-demo"
        @open="handleOpen"
        @close="handleClose"
        :router="true"
      >
        <el-submenu
          :index="navs.index"
          v-for="(navs, first) in navsBar"
          :key="first"
        >
          <template slot="title">
            <!--<i class="el-icon-location">-->
              <!--<img-->
                <!--:src="navs.iconUrl"-->
                <!--alt="icon"-->
                <!--width="100%"-->
                <!--v-if="navs.iconUrl"-->
              <!--/>-->
            <!--</i>-->
            <span>{{ navs.permName }}</span>
          </template>
          <el-menu-item
            :index="nav.index"
            v-for="(nav, second) in navs.children"
            :key="second"
            @click="goTo(nav.permName, nav.index)"
            >{{ nav.permName }}</el-menu-item
          >
        </el-submenu>
      </el-menu>
    </div>
  </div>
</template>

<script>
import PowerUserService from "service/PowerUserService";

import StorageService from "store/interfaces";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "navBar",
  data() {
    return {
      isCollapse: true,
      navsBar: [],
      myBtns: [],
    };
  },
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  computed: {
    ...mapGetters(["userInfo"]),
  },
  mounted() {
    if (this.userInfo == null) {
      this.$router.replace({
        name: "Login",
      });
      return;
    }
    this.getSelectPerms();
  },
  methods: {
    goTo(navsSecondName, routerPath) {
      this.$emit("addTab", navsSecondName, routerPath);
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    getSelectPerms() {
      const params = {
        id: this.userInfo.id,
      };
      this.doLoad(
        PowerUserService.selectperms,
        params,
        (res) => {
          const result = res.contents;
          this.navsBar = result;

          this.checkNav(result);
          this.recursion(this.navsBar);
          this.setBtnPerm(this.myBtns);
        },
        "信息获取失败"
      );
    },
    checkNav(nav) {
      nav.forEach((item, i) => {
        if (i == 2 && this.roleYuan.indexOf(this.userInfo.userName) > -1) {
          item.children.push(
            {
              children: [],
              permName: "数据抽样分析",
              index: "/index/taxlog",
            },
            {
              children: [],
              permName: "数据抽样分析-个人",
              index: "/index/taxlogperson",
            }
          );
        }
        if (i == 3 && this.roleXu.indexOf(this.userInfo.userName) > -1) {
          item.children.push({
            children: [],
            permName: "线路跳转配置",
            index: "/index/changechannelmanage",
          });
        }
        if (i == 4 && this.roleXu.indexOf(this.userInfo.userName) > -1) {
          item.children.push({
            children: [],
            permName: "提现统计",
            index: "/index/withdrawal",
          });
        }
        if (i == 2 && this.roleXu.indexOf(this.userInfo.userName) > -1) {
          item.children.push({
            children: [],
            permName: "平台账户明细",
            index: "/index/platformaccountdetails",
          });
        }
        if (i == 2 && this.roleXue.indexOf(this.userInfo.userName) > -1) {
          item.children.push({
            children: [],
            permName: "财务调账",
            index: "/index/financialreconciliation",
          });
        }
      });
    },
    defaultActive(val) {
      // console.log(this.navsBar);
      for (let i = 0; i < this.navsBar.length; i++) {
        for (let n = 0; n < this.navsBar[i].children.length; n++) {
          if (val.indexOf(this.navsBar[i].children[n].index) == 0) {
            return this.navsBar[i].children[n].index;
          }
        }
      }
    },
    recursion(arr) {
      arr.forEach((item) => {
        if (item.children.length) {
          this.recursion(item.children);
        } else if (item.menuType == 2) {
          this.myBtns.push(item.index);
        }
      });
    },
    ...mapActions({
      setBtnPerm: StorageService.perm.setBtnPerm,
    }),
  },
};
</script>

<style scoped>
.navbar {
  width: 260px;
  min-width: 260px;
  position: relative;
  transition: 0.4s;
  user-select: none;
  z-index: 1;
  box-shadow: 0px 2px 4px 0px rgba(2, 35, 51, 0.1);
}
.content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: auto;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  /*width: 260px;*/
}
/deep/ .el-submenu.is-active .el-icon-class {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/view/fragment/NavBar.vue